import React, { useState, useRef, useEffect } from "react";
import SendIcon from "@mui/icons-material/Send";
import StopIcon from "@mui/icons-material/Stop";
import { v4 as uuidv4 } from "uuid";
import useIsMobile from "../../hooks/useIsMobile";

const ChatInput = ({ onSubmit, onStop, isLoading, disabled }) => {
  const isMobile = useIsMobile();
  const [input, setInput] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    const ta = textareaRef.current;
    if (!ta) return;
    ta.style.height = "auto";
    const maxH = 200;
    if (ta.scrollHeight > maxH) {
      ta.style.height = `${maxH}px`;
      ta.style.overflow = "auto";
    } else {
      ta.style.height = `${ta.scrollHeight}px`;
      ta.style.overflow = "hidden";
    }
  }, [input]);

  const handleSend = () => {
    const text = input.trim();
    if (!text || isLoading || disabled) return;

    onSubmit({
      messages: [
        {
          type: "human",
          content: text,
          id: uuidv4(),
        },
      ],
    });
    setInput("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div
      style={{
        padding: isMobile ? "8px 12px 12px" : "12px 24px 16px",
        borderTop: "1px solid #e8e8e8",
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "8px",
          backgroundColor: "#f8f8f8",
          borderRadius: "12px",
          border: "1px solid #e0e0e0",
          padding: "8px 12px",
        }}
      >
        <textarea
          ref={textareaRef}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={disabled ? "Approve or reject the quote above" : "Type a message..."}
          disabled={disabled}
          rows={1}
          style={{
            flex: 1,
            border: "none",
            outline: "none",
            resize: "none",
            backgroundColor: "transparent",
            fontSize: isMobile ? "16px" : "14px",
            lineHeight: 1.5,
            fontFamily: "inherit",
            overflow: "hidden",
          }}
        />
        {isLoading ? (
          <button
            onClick={onStop}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "#ef4444",
              color: "#fff",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
            title="Stop"
          >
            <StopIcon style={{ fontSize: "18px" }} />
          </button>
        ) : (
          <button
            onClick={handleSend}
            disabled={disabled || !input.trim()}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: !disabled && input.trim() ? "#825ee7" : "#ccc",
              color: "#fff",
              cursor: !disabled && input.trim() ? "pointer" : "default",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
            title="Send"
          >
            <SendIcon style={{ fontSize: "18px" }} />
          </button>
        )}
      </div>
    </div>
  );
};

export default ChatInput;
